import React from "react";

import image1 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_001 Large.jpeg';
import image2 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_002 Large.jpeg';
import image3 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_003 Large.jpeg';
import image4 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_004 Large.jpeg';
import image5 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_005 Large.jpeg';
import image6 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_006 Large.jpeg';
import image7 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_007 Large.jpeg';
import image8 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_008 Large.jpeg';
import image9 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_009 Large.jpeg';
import image10 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_010 Large.jpeg';
import image11 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_011 Large.jpeg';
import image12 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_012 Large.jpeg';
import image13 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_013 Large.jpeg';
import image14 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_014 Large.jpeg';
import image15 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_015 Large.jpeg';
import image16 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_016 Large.jpeg';
import image17 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_017 Large.jpeg';
import image18 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_018 Large.jpeg';
import image19 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_019 Large.jpeg';
import image20 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_020 Large.jpeg';
import image21 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_021 Large.jpeg';
import image22 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_022 Large.jpeg';
import image23 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_023 Large.jpeg';
import image24 from './images/CANEDELLELACRIME/IL_CANE_DELLE_LACRIME_024 Large.jpeg';

const CaneDelleLacrime = () => {
    return (
    <div className="picture-gallery">
        <div className="photo-column">
            <div className="single">
                <img src={image1}/>
            </div>
            <div className="single">
                <img src={image2}/>
            </div>
            <div className="single">
                <img src={image3}/>
            </div>
            <div className="single">
                <img src={image4}/>
            </div>
            <div className="single">
                <img src={image5}/>
            </div>
            <div className="single">
                <img src={image6}/>
            </div>
            <div className="single">
                <img src={image7}/>
            </div>
            <div className="single">
                <img src={image8}/>
            </div>
            <div className="single">
                <img src={image9}/>
            </div>
            <div className="single">
                <img src={image10}/>
            </div>
            <div className="single">
                <img src={image11}/>
            </div>
            <div className="single">
                <img src={image12}/>
            </div>
            <div className="single">
                <img src={image13}/>
            </div>
            <div className="single">
                <img src={image14}/>
            </div>
            <div className="single">
                <img src={image15}/>
            </div>
            <div className="single">
                <img src={image16}/>
            </div>
            <div className="single">
                <img src={image17}/>
            </div>
            <div className="single">
                <img src={image18}/>
            </div>
            <div className="single">
                <img src={image19}/>
            </div>
            <div className="single">
                <img src={image20}/>
            </div>
            <div className="single">
                <img src={image21}/>
            </div>
            <div className="single">
                <img src={image22}/>
            </div>
            <div className="single">
                <img src={image23}/>
            </div>
            <div className="single">
                <img src={image24}/>
            </div>
        </div>
    </div>
    );
}

export default CaneDelleLacrime;